import React from 'react';
import { alpha } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box, InputBase, IconButton } from '@mui/material';

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
	width: '100%',
	'& input, & textarea': {
		webkitAppearance: 'none',
		MozAppearance: 'none',
		appearance: 'none',
		borderRadius: 4,
		backgroundColor: '#ffffff',
		padding: theme.spacing(1, 1.5),
		minHeight: 28,
		transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
		border: '1px solid #ced4da',
		fontSize: 15,
		'&:focus': {
			boxShadow: `${alpha('#999999', 0.25)} 0 0 0 0.2rem`,
			borderColor: theme.palette.primary.light
		}
	}
}));

export const StyledIconButton = styled(IconButton)({
	padding: '5px'
});

export const StyledIcon = styled('span')({
	fontSize: '20px',
	color: '#888'
});
